let { showMap } = require('../../actions/contacts');
let bitrix = require('../../actions/bitrix');

module.exports = {
    onLoad: [
        showMap,
        bitrix.resize
    ]
};



// WEBPACK FOOTER //
// ./signals/contacts/index.js